module.exports = "<ul class=list-state-history> <li class=list-item ng-repeat=\"history in vm.stateHistory\"> <div>{{ history.state.name }}</div> <div class=type-xsmall> {{ history.changedOn | date:'d MMMM yyyy' }} <span class=text-muted>{{ history.changedOn | date:'hh:mm' }}</span> </div> </li> </ul>";


//////////////////
// WEBPACK FOOTER
// ./features/account/my-packages/components/order-line-state-history.html
// module id = 529
// module chunks = 0